import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1827.70109 303.065275L698.834569 1431.80125 92.2989053 825.265588 0 917.564493 698.834569 1616.39906 1919.86945 395.23363z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCheckDarkLine = /*#__PURE__*/function (_Component) {
  _inherits(IconCheckDarkLine, _Component);

  var _super = _createSuper(IconCheckDarkLine);

  function IconCheckDarkLine() {
    _classCallCheck(this, IconCheckDarkLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconCheckDarkLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCheckDark",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCheckDarkLine.displayName = "IconCheckDarkLine";
  return IconCheckDarkLine;
}(Component);

IconCheckDarkLine.glyphName = 'check-dark';
IconCheckDarkLine.variant = 'Line';
IconCheckDarkLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCheckDarkLine;
export { IconCheckDarkLine };